export const en = {
  resourcesPage: {
    aboutSection: "About Your Volunteer Program",
    charitySection: "Your organizations, Your Choice",
    about: {
      title: 'About GreenShield Cares',
      description:
        'At GreenShield, caring is in our DNA. As a nonprofit social enterprise, we live our values daily, combining purpose, passion, and performance to make a difference in communities nationwide. Our industry-leading employee giving program empowers you to support the causes that matter most to you through donations and volunteering.',
    },
    givingLocal: {
      title: 'Give Local Program',
      description:
        'GreenShielders give locally through weekly payroll donations. Cast your vote for the nominated organizations to receive funding',
      nominateButton: 'Nominate Organization',
      optIn: 'Opt-in by submitting a request through greenshieldcares@greenshield.ca',
    },
    nominations: {
      title: 'Our Nominations',
      date: 'April 2025',
      emptyState: 'Organizations will be added once votes come in',
    },
    benefits: {
      title: 'Your Benefits',
      paidTime: {
        description:
          'Every year you have <strong>2 days (16 hours)</strong> of paid volunteer time through My Total Rewards',
        progress: 'hours volunteered',
      },
      volunteerDollars: {
        description:
          'Through our Volunteer Dollars for Charity program, GreenShield Cares offers <strong>$20 in volunteer rewards</strong> for every hour of personal time they volunteer with an eligible registered organization.',
        progress: 'hours volunteered',
      },
    },
    initiatives: {
      title: "GreenShield's Signature Initiatives",
      learnMore: 'Learn More',
      viewEvents: 'View Related Events',
      womensHealth: {
        title: "Women's Mental Health",
        body1:
          'Women are more likely to report higher levels of anxiety and depression than men, yet women are less likely to get the support they need.',
        body2:
          "As the only initiative of its kind in the country, the GreenShield Cares' Women's Mental Health program delivers culturally sensitive, trauma-informed virtual therapy at no cost for women aged 18 and above.",
        body3:
          'To date, we have Invested $4+ million in community partnerships to create and expand access mental health services and supported over 120,000 women with free care and meaningful support.',
      },
      youthHealth: {
        title: 'Youth Mental Health',
        body1:
          'Youth ages 16 – 24 experience mental health and substance use challenges at higher rates compared to older Canadians, but continue to face significant barriers to care.',
        body2:
          'In 2025, in collaboration with leading youth mental health organizations, GreenShield will be launching a comprehensive youth mental health solution, designed to address key barriers youth face to mental health support: care navigation, equitable access, and affordability.',
        body3:
          'Our new Youth Mental Health initiative builds on our commitment to advance health equity and ensure Canadian youth receive timely and culturally appropriate support.',
      },
      essentialMedicines: {
        title: 'Essential Medicines',
        body1:
          "William Wilkinson founded GreenShield to support Canadians who couldn't afford the medications they needed, believing that access to essential medicines is a fundamental human right.",
        body2:
          "We launched our Essential Medicines program in 2023 to fill the gaps for the one million Canadians who can't afford the medicines they need. In 2024, we expanded beyond Ontario into Nova Scotia, and plan to extend this program to more provinces in 2025.",
        body3:
          'To date, we have positively impacted over 90,000 lives with access to $1,000 annually in coverage for essential medicines.',
      },
    },
    resources: {
      title: 'Resources',
      subtext: 'Get more out of corporate volunteering',
    },
  },
}
